<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle :title="$route.meta.title"></PageTitle>
        <b-card>
          <div slot="footer">
            <b-row>
              <b-col sm="12">
                <button class="btn btn-success float-right mr-3 padder"
                        type="button" @click="create"
                >{{ $t('actions.save') }}
                </button>
                <router-link class="btn btn-primary float-right" role="button" :to="{name: 'jasperListRoute'}">
                  {{$t('actions.abort')}}
                </router-link>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label>Jasper URI</label>
                <b-form-input type="text" id="uri" v-model="uri" disabled
                              :value="uri"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group>
                <label>Filename <required-field /></label>
                <b-form-input type="text" id="filename" v-model="filename"
                              :value="filename" :state="errors.some((e) => e.field === 'filename')?false:null" aria-required="true" :required=true></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="8">
              <b-form-group>
                <label>Percorso <required-field /></label>
                <b-form-input type="text" id="path" v-model="path"
                              :value="path" :state="errors.some((e) => e.field === 'path')?false:null" aria-required="true" :required=true></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mb-3">
            <b-col sm="12">
              <label for="jasperData">Sorgente Jasper Report <required-field /></label>
              <codemirror id="jasperData" aria-required="true" :required=true v-model="jasperData" :options="cmOptions"></codemirror>
            </b-col>
          </b-row>
          <b-row class="dropzone m-1">
            <b-col sm="12">
              <div class="text-center p-3">
                <div v-if="$refs.upload && $refs.upload.dropActive" class="drop-active">
                  <h3>Rilascia il file per caricarlo</h3>
                </div>
                <h4>Trascina qui il file</h4>
                <vue-upload-component
                  class="btn btn-primary"
                  :multiple="false"
                  :drop="true"
                  :drop-directory="false"
                  @input-filter="inputFilter"
                  v-model="file"
                  ref="upload">
                  Seleziona il file
                </vue-upload-component>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
  import PageTitle from '../../components/PageTitle'
  // require component
  import {codemirror} from 'vue-codemirror'
  // require styles
  import 'codemirror/lib/codemirror.css'
  import 'codemirror/mode/xml/xml.js'
  import miniToastr from 'mini-toastr' //ES6
  import JasperService from "@/services/JasperService"
  import VueUploadComponent from 'vue-upload-component'
  import RequiredField from "../../components/RequiredField";

  const jasperService = JasperService.build();

  export default {
    name: 'JasperNew',
    components: {
      RequiredField,
      PageTitle,
      codemirror,
      VueUploadComponent
    },
    computed: {
      uri: function () {
        return `medmaker2:${this.path}/${this.filename}`

      }
    },
    data() {
      return {
        file: undefined,
        filename: '',
        path:'/',
        errors: [],
        jasperData: '',
        cmOptions: {
          tabSize: 4,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          mode: 'application/xml',
          lineWrapping: true,
          theme: 'default',
          opaque: true,
        }

      }
    },
    watch: {
      file: function (newFile, oldFile) {
        let _self = this;
        let reader = new FileReader();
        reader.onload = function () {
          let dataURL = reader.result;
          let buffer = _self.decode(dataURL);
          _self.jasperData = buffer.toString('ascii');
          miniToastr.success("Jasper caricato correttamente");

        };
        reader.readAsDataURL(newFile[0].file);
      }
    },
    created() {
      miniToastr.init(); // config can be passed here miniToastr.init(config)
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
    },
    methods: {
      async create() {
        if(!this.jasperData || this.uri === "medmaker2://"){
          let message;
          const allMessage = "Il nome del file, il percorso e la sorgente sono obbligatori";
          const jasperMessage = "La sorgente è obbligatoria";
          const uriMessage = "Il nome del file e il percorso sono obbligatori";

          if(this.uri === "medmaker2://"){
            message = uriMessage
          }else if(!this.jasperData){
            message = jasperMessage
          }else{
            message = allMessage
          }
          miniToastr.error(message);
        }else{
          try {
            await jasperService.createJrxml(this.uri, this.jasperData);
            this.$router.push({name: 'jasperShowRoute', params: {uri: this.uri}});
            miniToastr.success("Jasper creato con successo");
          } catch (exception) {
            miniToastr.error(exception.message);
          }
        }
      },
      reset(){
        this.filename = '';
        this.path = '';
        this.jasperData = '';
        this.file = undefined;
      },
      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          if (!/\.(xml|jrxml|txt)$/i.test(newFile.name)) {
            miniToastr.error('La tua scelta non è un xml/jrxml/txt');
            return prevent()
          }
        }
      },
      decode(uri) {

        //  dataurl    := "data:" [ mediatype ] [ ";base64" ] "," data
        //  mediatype  := [ type "/" subtype ] *( ";" parameter )
        //  data       := *urlchar
        //  parameter  := attribute "=" value

        var m = /^data:([^;,]+)?((?:;(?:[^;,]+))*?)(;base64)?,(.*)$/.exec(uri);
        if (!m) {
          throw new Error('Not a valid data URI: "' + truncate(uri, 20) + '"');
        }

        var media = '';
        var b64 = m[3];
        var body = m[4];
        var result = null;
        var charset = null;
        var mimetype = null;

        // If <mediatype> is omitted, it defaults to text/plain;charset=US-ASCII.
        // As a shorthand, "text/plain" can be omitted but the charset parameter
        // supplied.
        if (m[1]) {
          mimetype = m[1];
          media = mimetype + (m[2] || '');
        } else {
          mimetype = 'text/plain';
          if (m[2]) {
            media = mimetype + m[2];
          } else {
            charset = 'US-ASCII';
            media = 'text/plain;charset=US-ASCII';
          }
        }

        // The RFC doesn't say what the default encoding is if there is a mediatype
        // so we will return null.  For example, charset doesn't make sense for
        // binary types like image/png
        if (!charset && m[2]) {
          var cm = /;charset=([^;,]+)/.exec(m[2]);
          if (cm) {
            charset = cm[1];
          }
        }

        if (b64) {
          result = new Buffer(body, 'base64');
        } else {
          result = new Buffer(decodeURIComponent(body), 'ascii');
        }

        result.mimetype = mimetype;
        result.mediatype = media;
        result.charset = charset;

        return result;
      }
    }
  }
</script>
<style scoped>
  .dropzone {
    border: 1px solid lightgray;
    border-radius: 5px;
    background: #e4e7ea;
  }

  .dropzone .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
  }

  .dropzone .drop-active h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }
</style>
